export var DEFAULT_LANGUAGE = 'en';
export function createI18n(_a) {
    var localeDistPath = _a.localeDistPath, language = _a.language, defaultTranslations = _a.defaultTranslations, _b = _a.prefix, prefix = _b === void 0 ? 'messages' : _b, translations = _a.translations, originalInitI18n = _a.originalInitI18n;
    if (!originalInitI18n) {
        throw new Error("Can't initialize i18n without initI18n method.");
    }
    return originalInitI18n({
        locale: language,
        useSuspense: true,
        messages: translations,
        disableAutoInit: true,
        asyncMessagesLoader: function (locale) {
            // locales are fetched and not imported because
            // `bolt` SSR environment doesn't support webpack's `JsonpTemplatePlugin`
            // see also:
            //   https://github.com/wix-private/site-search/pull/369
            //   https://github.com/wix-private/site-search/commit/93a16dfbe1fcca9af7cc1abe88f0e0df222970c8
            return fetch("" + __webpack_public_path__ + localeDistPath + "/" + prefix + "_" + locale + ".json").then(function (r) {
                if (!r.ok) {
                    console.error("Can't load locale: " + language);
                    return Promise.resolve(defaultTranslations || {});
                }
                return r.json();
            });
        },
    });
}
//# sourceMappingURL=createI18n.js.map